import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'notifications_historic.list.pagination', {});
export const getFilters = (state) => get(state, 'notifications_historic.list.filters', {});

export const getNotificationsHistoricIds = (state) =>
  get(state, 'notifications_historic.list.result.notification_historic', []);
export const getNotificationsHistoric = (state) =>
  get(state, 'notifications_historic.list.entities.notification_historic', {});

export const getIsLoading = (state) => get(state, 'notifications_historic.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'notifications_historic.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'notifications_historic.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'notifications_historic.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'notifications_historic.form.isSaving', false);
export const getEditing = (state) => get(state, 'notifications_historic.form.editing', false);

export const getVisibleNotificationsHistoric = createSelector(
  [getNotificationsHistoricIds, getNotificationsHistoric],
  (ids, notifications_historic) =>
    ids
      .map((id) => notifications_historic[id])
      .filter((notificationHistoric) => !notificationHistoric.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/selectors/notifications_historic_selectors.js